module.exports = __webpack_public_path__ + "img/neid.3e3b78bb.png";